//call this fille in ac-tiered-qty-global.liquid file after this file call ac-filter-tiers.js
//<script type="text/javascript" src="{{ 'ac-quickviewVariantChangePrice.js' | asset_url}}" defer></script>
let productID = ''
 var VarintChangeSelectorPDpage = ".popup-wrapper .variant-selects.variant-selects--column  .product-form__input .form__variants label";
jQuery(document).on("click", VarintChangeSelectorPDpage, function () {
    // Find the closest parent having data-product-id
    
    let parentVariant = jQuery(this).closest("variant-selects[data-product-id]");
    
   productID = parentVariant.attr("data-product-id");
        


                setTimeout(function () {
                changePrice();
                }, 1500);
                     setTimeout(function () {
                    changePrice();
                }, 3000);
});


        const interval = setInterval(() => {
            const el = document.querySelector('.quickbuy-container .product-form[data-product-id]');

            if (!el) return; // still not in DOM
            let id = el.getAttribute('data-product-id')
             if (productID != id) {
                setTimeout(function () {
                    changePrice();
                    productID = el.getAttribute('data-product-id');
                }, 1000);
        }
//   const productId = el.getAttribute('data-product-id');


  //clearInterval(interval); // stop once found
}, 300);


  var changePrice = function () {
      if(productID){
       
   
    let tempTierObj = window.productsById[productID]
    if (!tempTierObj)return
  
    var selectedVariant = getSelectedVariant();

        let currencyRate = Shopify.currency.rate;
        currencyRate = Number(currencyRate);
        if (selectedVariant == "") {
            let id_ = Object.keys(tempTierObj.variantsPrices);
            selectedVariant = id_[0];
        }
        var mainProductPrice = tempTierObj.variantsPrices[selectedVariant];
        if (!mainProductPrice)return
        var mainProductPriceWithMoney = globalFields.formatMoney(mainProductPrice, globalFields.amount);
        var originalChangeQty = jQuery('input[name="quantity"]').val();
        originalChangeQty = Number(originalChangeQty);
        if (isNaN(originalChangeQty)) {
            originalChangeQty = 1;
        }
        var updatedItemPrice = 0;
        let tierData = tempTierObj.product_metafields;
        let productMetafieldValidation = filterProductMetafields(tierData, Number(selectedVariant));
        jQuery(".discount-badge").remove();
        if (selectedVariant != null && productMetafieldValidation != undefined && productMetafieldValidation.status && selectedVariant != "") {
            let tierObj = productMetafieldValidation;
            let tier_range_value = "";
            if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
                for (i = 0; i < tierObj.tier_min.length; i++) {
                    var tierPrice = parseFloat(tierObj.tier_values[i]);
                    var minTier = parseInt(tierObj.tier_min[i]),
                        maxTier = tierObj.tier_max[i] != "max" ? parseInt(tierObj.tier_max[i]) : tierObj.tier_max[i];
                    var updatedLinePrice = 0,
                        condition1 = !1,
                        condition2 = !1;
                    var originalPrice_ = mainProductPrice /100;
                    originalPrice_ = originalPrice_;
                    originalPrice_ = Number(originalPrice_);
                    originalChangeQty = tierObj.tier_min[0];
                    condition1 = originalChangeQty >= minTier;
                    condition2 = maxTier == "max" || originalChangeQty <= maxTier;
                    if (condition1 && condition2) {
                        break;
                    }
                }
                if (condition1 && condition2) {
                    if (tierObj.discount_type == "percentage") {
                        originalPrice_ = originalPrice_*100
                        var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(originalPrice_)));
                        updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(originalPrice_) - originalPriceCut);
                        updatedItemPrice = (updatedItemPrice.toFixed()/100)
                        tier_range_value = `${tierPrice}%`;
                    } else if (tierObj.discount_type == "fixed") {
                        updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(originalPrice_) - parseFloat(tierPrice * currencyRate));
                        tier_range_value = `${globalFields.formatMoney(tierPrice * currencyRate * 100, globalFields.amount)}`;
                    } else if (tierObj.discount_type == "fixed_price") {
                        updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice * currencyRate));
                        tier_range_value = `${globalFields.formatMoney(tierPrice * currencyRate * 100, globalFields.amount)}`;
                    }
                    updatedItemPrice = globalFields.formatMoney(Number(updatedItemPrice).toFixed(2), globalFields.amount);
                    jQuery(".discount-badge").remove();
                    jQuery(".ac-custom-div").css({ position: "relative", display: "flex" });
                    // jQuery("#product-box .entry-content .ac-custom-div,.discount-badge").append(
                    //     `<div class="main-cntr discount-badge" style="position: relative;bottom: 4px;left: 4px;height: 50px;max-height: 100px;font-size: 16px;font-weight: 300;"> <div class="ac-tier-range"><span>- ${tier_range_value}</span></div> </div>`
                    // );
                    jQuery(".quickbuy-container .price-container .price-area,.ac-discounted-price").html(
                        ` <span class="money  ac-discounted-price"><s> ${mainProductPriceWithMoney}</s><span> ${updatedItemPrice}</span></span>`
                    );
                } else {
                    jQuery(".quickbuy-container .price-container .price-area,.ac-discounted-price").html(`<span class="money ac-discounted-price" > ${mainProductPriceWithMoney} </span>`);
                }
            }
        } else {
            jQuery(".quickbuy-container .price-container .price-area,.ac-discounted-price").html(`<span class="money ac-discounted-price"> ${mainProductPriceWithMoney} </span>`);
        }

   }
        
    };

    window.addEventListener("load", (event) => {
    setTimeout(function () {
        changePrice();
    }, 800);
    changePrice();
});


function getSelectedVariant() {
    try {
        // Define your selectors cleanly
        const variantSelector = `input[name^="id"]:checked,
                                 select[name^="id"],
                                 input[name="id"],
                                 input[type="hidden"][name^="id"]`;

        // Try first form sources
        const primaryForm = jQuery('form[action="/cart/add"], #add-to-cart-form');
        let selectedVariant = primaryForm.find(variantSelector).val();

        // If empty/undefined/null then fallback
        if (!selectedVariant) {
            const secondaryForm = jQuery('form[data-type="add-to-cart-form"], #add-to-cart-form');
            selectedVariant = secondaryForm.find(variantSelector).val();
        }

        // Final safety check
        if (!selectedVariant) {
            return null;
        }

        return selectedVariant;

    } catch (err) {
        console.error("Error while getting selected variant:", err);
        return null;
    }
}




changePrice();
